"use client";

import { ArrowRight, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VamosExpandirSeusNegocios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="232590" id="partnering-for-clarity" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] md:w-[800px] md:h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-none bg-primary/10 text-primary text-xs font-mono mb-8 border border-border shadow-sm uppercase tracking-widest">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            Institutional Access
          </div>

          {}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 tracking-tighter text-balance text-foreground">
            Integrate AIB Data into Your Workflow
          </h2>

          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto text-balance leading-relaxed font-default">
            Access Australia’s independent household economic indicators. We provide the precision and clarity required for high-stakes reporting and policy development.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto h-14 px-8 text-base rounded-sm shadow-none bg-foreground text-background hover:bg-foreground/90">
              <Link to="/MediaCentrePage">
                <PhoneCall className="mr-2 size-5" />
                For Media Enquiries
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs has-[>svg]:px-4 w-full h-14 px-8 text-base border-border rounded-sm backdrop-blur-sm group text-primary-foreground !bg-[rgba(255,255,255,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 sm:w-auto hover:bg-accent/10">
              <Link to="/MethodologyPage">
                For Government & API
                <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}